module.exports = __webpack_public_path__ + "static/media/preview.315a08c9.svg";